import { Injectable } from '@angular/core';
import { ONBOARD_CONSTANTS } from '../../app.constants';
import { SwitchDeviceRequestModel } from './switch.model';
import { TravelersService } from '../travelers/travelers.service';
import { environment } from '../../../environments/environment';
import {PnrFormDataModel} from '../travelers/travelers.model';

@Injectable()
export class SwitchService {
  private getdeviceTypeResponse: any;
  private getDeviceResponse: any;
  private switchDeviceRequest: SwitchDeviceRequestModel;
  public deviceInfoData: any;
  public connectedCountValue: any;
  loginFromActivate = false;

  constructor(private travelersService: TravelersService) { }

  getUrls() {
    const urls = { wifiLogoUrl: '' };
    if (window.location.hostname === 'localhost' || window.location.hostname.indexOf('d360d') >= 0) {
      urls.wifiLogoUrl = 'https://www.sas.se/content/dam/sas/images/icons/WiFi.svg';
    } else {
      urls.wifiLogoUrl = `${window.location.protocol}//${window.location.hostname}${ONBOARD_CONSTANTS.WIFI_LOGO_URL}`;
    }
    return urls;
  }

  setDataFromLanding(getdeviceTypeResponse, getDeviceResponse, passengerIdentifier) {
    this.getDeviceResponse = getDeviceResponse;
    this.getdeviceTypeResponse = getdeviceTypeResponse;

    for (const device of this.getdeviceTypeResponse.devices) {
      if (device.status.code === 'FULL') {
        this.switchDeviceRequest = {
          url: environment.apiBaseUrl + ONBOARD_CONSTANTS.SWITCH_DEVICE,
          data: {
            'toDevice': this.getDeviceResponse.token,
            'fromDevice' : device.token,
            'flightId': this.getDeviceResponse.flightId,
            'passengerId': passengerIdentifier
          }
        };
      }
    }
  }

  getDeviceInfoRequest(getDeviceResponse, paxId, type) {
    const deviceDetails = getDeviceResponse;
    const passengerDetails = this.travelersService.getPnrFormData();
    let pnr, firstName, lastName, formPassengerRequest, request;
    if (type === 'login') {
      request = ONBOARD_CONSTANTS.GET_PASSENGER_PAXID.replace('<<passengerId>>', paxId);
      formPassengerRequest = `${request}&expand=DeviceInfo`;
    } else {
      if (!passengerDetails && deviceDetails.passenger) {
        pnr = deviceDetails.passenger.bookingReference;
        firstName = deviceDetails.passenger.firstName;
        lastName = deviceDetails.passenger.lastName;
        this.setPassengerDetails(deviceDetails);
      } else {
        pnr = passengerDetails.pnr;
        firstName = passengerDetails.firstname;
        lastName = passengerDetails.secondname;
      }
      request = ONBOARD_CONSTANTS.GET_PASSENGER.replace('<<pnr>>', pnr).replace('<<fn>>', firstName).replace('<<ln>>', lastName);
      formPassengerRequest = `${request}&flightId=${deviceDetails.flightId}&expand=DeviceInfo`;
    }
    const getPassengerRequest = {
      url: environment.apiBaseUrl + formPassengerRequest,
    };
    return getPassengerRequest;
  }

  setPassengerDetails(deviceDetails) {
    const passengerDetail = new PnrFormDataModel();
    passengerDetail.firstname = deviceDetails.passenger.firstName;
    passengerDetail.secondname = deviceDetails.passenger.lastName;
    passengerDetail.pnr = deviceDetails.passenger.bookingReference;
    this.travelersService.setPnrFormData(passengerDetail);
  }

  getSwitchDeviceRequest(): SwitchDeviceRequestModel {
    return this.switchDeviceRequest;
  }

  setSwitchDeviceRequest(deviceToken) {
    this.switchDeviceRequest.data.fromDevice = deviceToken;
  }

  getDeviceTypeData(): any {
    return this.getdeviceTypeResponse;
  }

  getGetDeviceData(): any {
    return this.getDeviceResponse;
  }

  setLoginFromActivate(value) {
    this.loginFromActivate = value;
  }

  getLoginFromActivate() {
    return this.loginFromActivate;
  }

  setConnectedCount(value) {
    this.connectedCountValue = value;
  }

  getConnectedCount() {
    return this.connectedCountValue;
  }
}
